import { render, staticRenderFns } from "./LiabilityDetails.vue?vue&type=template&id=36acb842&"
import script from "./LiabilityDetails.vue?vue&type=script&lang=js&"
export * from "./LiabilityDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports